import React, { useEffect, useState, useContext } from "react";
import StoreContext from "contexts/StoreContext";
import { Card, Table } from "react-bootstrap";
import { apiService } from "service/ApiService";
import { ClipLoader } from "react-spinners";
import { useTranslation } from "react-i18next";

export default function SalesByUser() {
  const { t } = useTranslation();
  const { storeId, setStoreId } = useContext(StoreContext);
  const [userData, setUserData] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showLoader, setShowLoader] = useState(true);

  const fetchData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get(`api/v1/stores/${storeId}/user-sales`);
      const myTotal = _.sumBy(dataResponse, "total");
      let myCount = 0;
      dataResponse.map((el) => {
        el.percentage = ((el.total / myTotal) * 100).toFixed(0);
        myCount += Number(el.count);
      });
      setUserData(dataResponse);
      setTotal(myTotal);
      setTotalCount(myCount);
    } catch (error) {
      console.error("Error fetching data:", error);
      setUserData([]);
      setTotal(0);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (!storeId) return;
    fetchData();
  }, [storeId]);

  return (
    <>
      <Card className="strpied-tabled-with-hover">
        <Card.Header>
          <Card.Title as="h5">{t("dashboard.reports.salesByUser")}</Card.Title>
          <p className="card-category">{t("dashboard.reports.excludesOpenOrders")}</p>
        </Card.Header>
        <Card.Body className="table-responsive p-0">
          {showLoader ? (
            <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
              <ClipLoader size={50} color={"#ff6fbc"} />
            </div>
          ) : (
            <Table className="table-hover table-striped w-full align-text-right">
              <tbody>
                {userData.map((dt) => {
                  return (
                    <tr key={dt.store_user_name}>
                      <td className="bold align-text-left" style={{ color: dt.store_user_color }}>
                        {dt.store_user_name}
                      </td>
                      <td>{dt.count}</td>
                      <td>{dt.total.toFixed(2)}</td>
                      <td>{dt.percentage}%</td>
                    </tr>
                  );
                })}
                {total !== 0 ? (
                  <tr>
                    <td className="bold align-text-left">{t("dashboard.reports.total")}</td>
                    <td className="bold">{totalCount}</td>
                    <td className="bold">{total.toFixed(2)}</td>
                    <td></td>
                  </tr>
                ) : (
                  <></>
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </>
  );
}
